import React, { FC } from 'react';
import { Form, Icon, Popup } from 'semantic-ui-react';
import { Threshold } from '@vidende/contracts';

interface OutlierProps {
    value?: string | number | Threshold;
    name?: string;
    // Loosely typed on purpose: the host fields (Text, Number, RichTextArea…)
    // each declare their own narrower onChange and pass it straight through.
    onChange?: (
        event: any,
        data: {
            value: any;
            name: any;
            outlier?: boolean;
            excludeFromStatistics?: boolean;
        },
    ) => void;
    outlier?: boolean;
    excludeFromStatistics?: boolean;
}

const Outlier: FC<OutlierProps> = ({
    value,
    name,
    onChange,
    outlier,
    excludeFromStatistics,
}) => {
    return (
        <Popup
            wide
            trigger={<Icon name="times circle outline" />}
            content={
                <Form.Group>
                    <Form.Checkbox
                        onChange={(_, data) => {
                            onChange!(null, {
                                value,
                                name,
                                outlier: data.checked,
                            });
                        }}
                        label="Outlier"
                        checked={outlier}
                    />
                    <Form.Checkbox
                        label="Exclude From Statistics"
                        onChange={(_, data) => {
                            onChange!(null, {
                                value,
                                name,
                                excludeFromStatistics: data.checked,
                            });
                        }}
                        checked={excludeFromStatistics}
                    />
                </Form.Group>
            }
            hoverable={true}
            position="bottom center"
        />
    );
};

export default Outlier;
